import React, { useState } from 'react';
import styled from 'styled-components';

import ImageThumbnails from './images/ImageThumbnails';
import MainImage from './images/MainImage';

const Images = (props) => {
  const { images } = props;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  return (
    <StyledImages>
      <MainImage
        images={images}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
      />
      <ImageThumbnails
        images={images}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
      />
    </StyledImages>
  );
};

const StyledImages = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  flex-direction: column;

  @media ${({ theme }) => theme.mediumUp} {
    flex-direction: row;
  }
`;

export default Images;
